export default __webpack_public_path__ + "static/media/slider-1-mobile.d2689b5e.png";